module.exports = __webpack_public_path__ + "img/american-logo-laptop.61b280e4.svg";